// Projects Board data — committed ingest output (SYSTEM/kit-os/mirror/ingest-projects.py).
import projectsData from "./projectsBoard.json";

export const CARDS = projectsData.cards;
export const STAMP = projectsData.stamp;

export function boardClock(now = new Date()) {
  const ingested = new Date(STAMP.ingested_at);
  const hours = Math.max(0, (now.getTime() - ingested.getTime()) / 36e5);
  const fresh = hours <= 24;
  const dead = hours > 72;
  const stampText = ingested.toLocaleString("en-US", {
    month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  });
  return { hours, fresh, dead, stampText };
}
